import React, { useState } from "react";
import { Button, Input } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';


const FilterList = ({ searchKeyword, _setSearchKeyword, _handleFilter, _clear, _setReload, reload }) => {

    // const [pagevalue, setPagevalue] = useState(null)

    const [keyword, setKeyword] = useState('');
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            _handleFilter({ searchKeyword })
        }
      };


    return (
        <>
            <div className='filter-head'>
                <h2>Filter</h2>
                <div className='inner'>
                    <form className='form-row d-flex align-items-center'>
                        <div className='input-cell'>
                            <Input type='text' value={searchKeyword} placeholder='' className='form-control' onChange={(e) => _setSearchKeyword(e.target.value.trim())} onKeyDown={handleKeyDown} />
                        </div>
                        <div className='input-btns d-inline-flex align-items-center'>
                            <Button color='primary' type="button" onClick={(e) => { _handleFilter({ searchKeyword }) }}>
                                Apply Filters
                            </Button>
                            <Button color='link' className='clear-filter-btn' type="button" onClick={_clear}>
                                <FontAwesomeIcon icon={faTimes} />
                                Clear Filters
                            </Button>
                            <Button onClick={()=> _setReload(!reload)} color="link" className="reload-btn d-inline-flex align-items-center" type="button">
                                <span className="icon d-inline-flex">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                    </svg>
                                </span>
                                Reload
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );

}
export default FilterList;